/**
 * @packageDocumentation
 * @module HackerAPI.User.Hacker.Urls
 */
import { __extends } from "tslib";
import Base from "../../../base/base";
/**
 * A data container for all profile links that someone could use to stalk a user
 * @struct
 * @extends { HackerAPI.Base }
 */
var Urls = /** @class */ (function (_super) {
    __extends(Urls, _super);
    /**
     * Creates a new Urls instance
     * @constructor
     * @param links
     */
    function Urls(_a) {
        var _b = _a === void 0 ? {} : _a, behance = _b.behance, bitbucket = _b.bitbucket, devpost = _b.devpost, deviantart = _b.deviantart, dribbble = _b.dribbble, github = _b.github, jsfiddle = _b.jsfiddle, linkedin = _b.linkedin, resume = _b.resume, soundcloud = _b.soundcloud, facebook = _b.facebook, twitter = _b.twitter, instagram = _b.instagram, flickr = _b.flickr, portfolio = _b.portfolio;
        var _this = _super.call(this) || this;
        /**
         * @type { string }
         */
        _this.behance = behance || null;
        /**
         * @type { string }
         */
        _this.bitbucket = bitbucket || null;
        /**
         * @type { string }
         */
        _this.devpost = devpost || null;
        /**
         * @type { string }
         */
        _this.deviantart = deviantart || null;
        /**
         * @type { string }
         */
        _this.dribbble = dribbble || null;
        /**
         * @type { string }
         */
        _this.github = github || null;
        /**
         * @type { string }
         */
        _this.jsfiddle = jsfiddle || null;
        /**
         * @type { string }
         */
        _this.linkedin = linkedin || null;
        /**
         * @type { string }
         */
        _this.resume = resume || null;
        /**
         * @type { string }
         */
        _this.soundcloud = soundcloud || null;
        /**
         * @type { string }
         */
        _this.facebook = facebook || null;
        /**
         * @type { string }
         */
        _this.twitter = twitter || null;
        /**
         * @type { string }
         */
        _this.instagram = instagram || null;
        /**
         * @type { string }
         */
        _this.flickr = flickr || null;
        /**
         * @type { string }
         */
        _this.portfolio = portfolio || null;
        return _this;
    }
    return Urls;
}(Base));
export default Urls;
//# sourceMappingURL=urls.js.map